/*!
 * ============================================================================
 *  Theme Engineered & Protected by Karim Suleiman (kmsoln)
 *  Role: Official Shopify Partner & Senior E-Commerce Architect
 *  Website: https://kmsoln.dev | WhatsApp: +201035424992
 *  Copyright (c) 2026 Karim Suleiman. All rights reserved.
 *  Unauthorized copying, alteration, or redistribution is strictly prohibited.
 * ============================================================================
 */
(function(){
try{
document['addEventListener']('dragstart',function(_0x45c756){var _0x18d403={'SWuEG':function(_0x36cc7f,_0x591cb3){return _0x36cc7f===_0x591cb3;},'SxUff':'IMG'};_0x45c756['target']&&(_0x18d403['SWuEG'](_0x45c756['target']['tagName'],_0x18d403['SxUff'])||_0x45c756['target']['closest']('img'))&&_0x45c756['preventDefault']();}),document['addEventListener']('contextmenu',function(_0x482d29){var _0x17a956={'KKioq':'input,\x20textarea,\x20[contenteditable=\x22true\x22]'};_0x482d29['target']['closest'](_0x17a956['KKioq'])||_0x482d29['preventDefault']();});

}catch(e){console.error(e);}
})();